import React from 'react';
import { PartnerItem } from '../../utils/partnersData';
import { useTranslation } from 'react-i18next';

type PartnersGridProps = {
  items: PartnerItem[];
};

const PartnersGrid: React.FC<PartnersGridProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <article
              key={item.id}
              id={item.anchorId}
              className={`bg-[#F7F8FA] rounded-xl p-6 border border-[#E2E8F0] hover:border-teal-200 hover:shadow-lg transition-all duration-300 group ${
                item.highlight ? 'border-teal-200 shadow-lg' : ''
              } scroll-mt-28`}
            >
              <div className="w-full h-16 flex items-center justify-start mb-4">
                <img
                  src={item.logo}
                  alt={t('partnersSection.grid.logoAlt', { name: item.name, defaultValue: `${item.name} logo` })}
                  className={`max-h-14 max-w-[140px] object-contain grayscale group-hover:grayscale-0 transition-all duration-300 ${
                    item.name === 'TSL Products' ? 'brightness-0 saturate-100' : ''
                  } ${
                    item.name === 'Dafo Vehicle Fire Suppression' ? 'max-h-16 max-w-[220px]' : ''
                  } ${
                    item.name === 'Triad Speakers' ? 'max-h-16 max-w-[190px]' : ''
                  } ${
                    item.name === 'Focus Lighting' ? 'brightness-0 saturate-100' : ''
                  }`}
                />
              </div>
              <h3 className="font-bold text-[#0F172A] text-base">{item.name}</h3>
              <span className="text-xs text-teal-600 font-semibold">
                {t(`partnersSection.partners.${item.anchorId}.category`, { defaultValue: item.category })}
              </span>
              <p className="text-[#64748B] text-sm mt-2 leading-relaxed">
                {t(`partnersSection.partners.${item.anchorId}.description`, { defaultValue: item.description })}
              </p>
              <a
                href={`https://${item.website}`}
                target="_blank"
                rel="noreferrer"
                className="inline-block mt-3 text-xs text-slate-500 hover:text-teal-600 transition-colors"
              >
                {item.website}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersGrid;
